import { getMember } from '@wix/ambassador-members-v1-member/http';
import { Set } from '@wix/ambassador-members-v1-member/types';
export async function getMemberContactData(options) {
    const { memberId, httpClient } = options;
    if (!memberId) {
        return undefined;
    }
    try {
        const response = await httpClient.request(getMember({
            id: memberId,
            fieldsets: [Set.FULL],
        }));
        const member = response?.data?.member;
        if (!member) {
            return undefined;
        }
        const { contact } = member;
        const email = member.loginEmail?.trim() || contact?.emails?.[0]?.trim();
        const phone = contact?.phones?.[0]?.trim();
        const firstName = contact?.firstName?.trim();
        const lastName = contact?.lastName?.trim();
        return {
            firstName: firstName || undefined,
            lastName: lastName || undefined,
            email: email || undefined,
            phone: phone || undefined,
        };
    }
    catch {
        return undefined;
    }
}
//# sourceMappingURL=get-member-contact.js.map